<template>
    <el-tabs v-model="activeState" class="demo-tabs" @tab-change="handleClick">
        <el-tab-pane label="未配置" :name="0">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="场站名称：">
                    <el-select
                        filterable
                        v-model="selectList1"
                        style="width: 240px"
                        placeholder="请选择场站"
                        collapse-tags
                        multiple
                        clearable
                        @change="e => changeSelect1(e)"
                    >
                        <div class="checkboxWrapper">
                        <el-checkbox v-model="checked1" @change="checkChange1">
                            全选
                        </el-checkbox>
                        </div>
                        <el-option
                        v-for="item in stationOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getList1">查询</el-button>
                    <el-button type="success" @click="addSetting">配置</el-button>
                </el-form-item>
            </el-form>
            <el-table class="table_wrapper" :data="tableData1" @selection-change="handleSelectionChange" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
                <el-table-column type="selection" width="55" />
                <el-table-column label="场站" min-width="300" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.stationName }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="设备名称" min-width="150" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.pileName }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="设备编号" width="250" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.pileNo }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="地址" min-width="300" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.stationAddress }}</span>
                    </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination
                v-model:current-page="currentPage1"
                v-model:page-size="pageSize1"
                :total="total1"
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
            />
        </el-tab-pane>

        <el-tab-pane label="已配置" :name="1">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="场站名称：">
                    <el-select
                        filterable
                        v-model="selectList2"
                        style="width: 240px"
                        placeholder="请选择场站"
                        collapse-tags
                        multiple
                        clearable
                        @change="e => changeSelect2(e)"
                    >
                        <div class="checkboxWrapper">
                        <el-checkbox v-model="checked2" @change="checkChange2">
                            全选
                        </el-checkbox>
                        </div>
                        <el-option
                        v-for="item in stationOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="计费模板：">
                    <el-select
                        filterable
                        v-model="selectList3"
                        style="width: 300px"
                        placeholder="请选择计费模板"
                        collapse-tags
                        multiple
                        clearable
                        @change="e => changeSelect3(e)"
                    >
                        <div class="checkboxWrapper">
                        <el-checkbox v-model="checked3" @change="checkChange3">
                            全选
                        </el-checkbox>
                        </div>
                        <el-option
                        v-for="item in templateOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getList2">查询</el-button>
                    <el-button  type="primary" plain @click="updateSetting">修改配置</el-button>
                    <el-button  type="danger" plain @click="deleteState">删除</el-button>
                </el-form-item>
            </el-form>
            <el-table class="table_wrapper" :data="tableData2" @selection-change="handleSelectionChange2" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
                <el-table-column type="selection" width="55" />
                <el-table-column label="场站" min-width="300" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.stationName }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="设备名称" min-width="150" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.pileName }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="设备编号" width="250" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.pileNo }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="地址" min-width="300" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.stationAddress }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="计费模板" min-width="300" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.templateName }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" min-width="200">
                    <template #default="scope">
                    <div>
                        <span>{{scope.row.createTime}}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="更新时间" min-width="200">
                    <template #default="scope">
                    <div>
                        <span>{{scope.row.updateTime}}</span>
                    </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination
                v-model:current-page="currentPage2"
                v-model:page-size="pageSize2"
                :total="total2"
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
            />
        </el-tab-pane>
    </el-tabs>

    <!-- 模板配置 -->
    <el-drawer
        v-model="drawer"
        :title="drawerTitle"
        direction="rtl"
        :before-close="handleClose"
    >
    <el-form :inline="true">
        <el-form-item label="计费模板：" prop="">
            <el-select style="width: 300px;" v-model="settingInfo.templateId" placeholder="请选择计费模板">
                <el-option
                    v-for="item in templateOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
            </el-select>
        </el-form-item>
    </el-form>
    <template #footer>
    <div class="dialog-footer">
        <el-button @click="closeAdd">取消</el-button>
        <el-button type="primary" @click="save()">确定</el-button>
    </div>
    </template>

    </el-drawer>

</template>

<script>
import { ElMessage } from 'element-plus';
    export default {
        name:'SetTemplate',
        data() {
            return {
                drawer: false,
                drawerTitle: '',
                settingInfo: { //配置信息
                    templateId: '', //计费模板ID
                },
                isUpdate: false, //是否修改
                isLoadData: false, //是否已加载数据
                total1: 0, //总条数
                currentPage1: 1, //当前页
                pageSize1: 10, //每页显示条数
                total2: 0, //总条数
                currentPage2: 1, //当前页
                pageSize2: 10, //每页显示条数
                stationOptions: this.$store.state.stationList,
                templateOptions: [],
                selectList1: [],
                checked1: false,
                selectList2: [],
                checked2: false,
                selectList3: [],
                checked3: false,
                activeState: 0,
                tableData1:[
                    // {
                    //     stationName: 'Station1',
                    //     pileName: 'Pile1',
                    //     pileNo: 'PileNo1',
                    //     stationAddress: 'Address1' 
                    // }
                ],
                tableData2:[
                    // {
                    //     stationName: 'Station2',
                    //     pileName: 'Pile1',
                    //     pileNo: 'PileNo1',
                    //     stationAddress: 'Address1' 
                    // }
                ],
                selection: [],
                selection2: [],
            };
        },
        mounted() {
            this.getList1(); //获取列表
            this.getTemplate(); //获取模板
        },
        watch: {
            '$store.state.stationList': {
                handler(newVal) {
                    if (newVal && newVal.length > 0) {
                        this.stationOptions = newVal;
                    }
                },
                immediate: true
            }
        },
        methods: {
            closeAdd() {
                this.$confirm('此操作不会保存更改哦，确定关闭吗？',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
                .then(_ => {
                    this.drawer = false;
                })
                .catch(_ => {});
            },
            handleClose(done) {
                this.$confirm('此操作不会保存更改哦，确定关闭吗？',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
                .then(_ => {
                    done();
                })
                .catch(_ => {});
            },
            save() {
                //保存
                let that = this;
                let paramData = [];
                let url = '';
                if(that.settingInfo.templateId==''){
                    ElMessage({
                        message: '请选择计费模板',
                        type:'warning',
                    }); 
                    return;
                }
                if(that.isUpdate){
                    //修改
                    that.selection2.forEach(item => {
                        let param = {};
                        param.id = item.id;
                        param.pileNo = item.pileNo;
                        param.pileName = item.pileName;
                        param.stationId = item.stationId;
                        param.stationName = item.stationName;
                        param.stationAddress = item.stationAddress;
                        param.templateId = that.settingInfo.templateId;
                        paramData.push(param);
                        url = "platform-server/template/config/edit";
                    });
                }else{
                    //新增
                    that.selection.forEach(item => {
                        let param = {};
                        param.pileNo = item.pileNo;
                        param.pileName = item.pileName;
                        param.stationId = item.stationId;
                        param.stationName = item.stationName;
                        param.stationAddress = item.stationAddress;
                        param.templateId = that.settingInfo.templateId;
                        paramData.push(param);
                        url = "platform-server/template/config/set";
                    });
                }
                that.$axios.post(url,JSON.stringify(paramData)).then(result => {
                    if(result.code==200){
                        ElMessage({
                            message: '配置成功',
                            type: 'success',
                        });
                        that.drawer = false;
                        that.getList1(); //获取列表
                        that.getList2(); //获取列表
                    }
                });
            },
            deleteState(){
                //删除
                let that = this;
                if(this.selection2.length==0){
                    ElMessage({
                        message: '请选择要删除的记录',
                        type:'warning',
                    });
                    return; 
                }
                this.$confirm('确定删除选中的记录吗？',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
                .then(_ => {
                    let paramData = that.selection2.map(item => item.id);
                    this.$axios.post("platform-server/template/config/del",JSON.stringify(paramData)).then(result => {
                        if(result.code==200){
                            ElMessage({
                                message: '删除成功',
                                type:'success',
                            })
                            that.getList1(); //获取列表
                            that.getList2(); //获取列表
                        }
                    })   
                }) 
            },
            addSetting() {
                if(this.selection.length==0){
                    ElMessage({
                        message: '请选择要配置的记录',
                        type:'warning',
                    });
                    return; 
                }
                this.drawerTitle = '配置模板';
                this.isUpdate = false;
                this.drawer = true;  
            },
            updateSetting() {
                if(this.selection2.length==0){
                    ElMessage({
                        message: '请选择要配置的记录',
                        type:'warning',
                    });
                    return; 
                }
                this.drawerTitle = '修改配置';
                this.isUpdate = true;
                this.drawer = true;  
            },
            handleSizeChange1 (val) { //每页显示条数
              this.pageSize1 = val;
              this.currentPage1 = 1;
              this.getList1();
            },
            handleCurrentChange1(val) { //当前页
                this.currentPage1 = val;
                this.getList1(); //获取列表
            },
            handleSizeChange2 (val) { //每页显示条数
              this.pageSize2 = val;
              this.currentPage2 = 1;
              this.getList2();
            },
            handleCurrentChange2(val) { //当前页
                this.currentPage2 = val;
                this.getList2(); //获取列表
            },
            getList1(){
                //获取列表
                let that = this;
                let param = {};
                param.state = 0;
                param.page = that.currentPage1;
                param.pageSize = that.pageSize1;
                param.stationIds = that.selectList1;
                // console.log(param);
                that.$axios.post("platform-server/template/config/list",JSON.stringify(param)).then(result => {
                    if(result.code==200){
                        that.tableData1 = result.data.records;
                        that.total1 = result.data.total; 
                    }
                })
            },
            getList2(){
                //获取列表
                let that = this;
                let param = {};
                param.state = 1;
                param.page = that.currentPage2;
                param.pageSize = that.pageSize2;
                param.stationIds = that.selectList2;
                param.templateIds = that.selectList3;
                that.$axios.post("platform-server/template/config/list",JSON.stringify(param)).then(result => {
                    if(result.code==200){
                        that.tableData2 = result.data.records;
                        that.total2 = result.data.total; 
                    }
                })
            },
            getTemplate(){
                //获取模板
                let that = this;
                that.$axios.post("platform-server/charge/template/all",{}).then(result => {
                    if(result.code==200){
                        that.templateOptions = result.data;
                    }
                })
            },
            checkChange1(val) {
                if (val) {
                    this.selectList1 = this.stationOptions.map(item => item.id); 
                }else {
                    this.selectList1 = []; 
                }
            },
            changeSelect1(val) {
                if (val.length === this.stationOptions.length) {
                    this.checked1 = true;
                }else {
                    this.checked1 = false; 
                }
            },
            checkChange2(val) {
                if (val) {
                    this.selectList2 = this.stationOptions.map(item => item.id); 
                }else {
                    this.selectList2 = []; 
                }
            },
            changeSelect2(val) {
                if (val.length === this.stationOptions.length) {
                    this.checked2 = true;
                }else {
                    this.checked2 = false; 
                }
            },
            checkChange3(val) {
                if (val) {
                    this.selectList3 = this.templateOptions.map(item => item.id); 
                }else {
                    this.selectList3 = []; 
                }
            },
            changeSelect3(val) {
                if (val.length === this.templateOptions.length) {
                    this.checked3 = true;
                }else {
                    this.checked3 = false; 
                }
            },
            handleClick(tab, event) {
                // console.log(this.activeState);
                if(this.activeState == 1 && !this.isLoadData){
                    this.getList2(); //获取列表
                    this.isLoadData = true;
                }
            },
            handleSelectionChange(val) {
                this.selection = val;
                // console.log('selection change: ', val); 
            },
            handleSelectionChange2(val) {
                this.selection2 = val;
                // console.log('selection change: ', val); 
            }
        }
    };

</script>


<style lang="scss" scoped>
.checkboxWrapper {
  padding: 3px 20px;
  border-bottom: 1px solid #ccc;
}
</style>